import React from "react";
import { FormControl, FormHelperText, FormLabel } from "@mui/material";

import Helpers from "../../commons/helpers";
import { Typography } from "@maysoft/common-component-react";

interface IProps {
    title: string;
    required?: boolean;
    errorMessage?: string;
    children: React.ReactNode;
}

const InputGroup: React.FC<IProps> = (props: IProps) => {
    const { title, children, required } = props;
    return (
        <>
            <FormControl
                fullWidth
                component="fieldset"
                className={"default-fieldset"}
                error={!Helpers.isNullOrEmpty(props.errorMessage)}>
                <FormLabel
                    component="legend"
                    className="default-legend"
                >
                    <Typography variant="button" fontWeight="regular">
                        {required ? `${title} *` : title}
                    </Typography>
                </FormLabel>
                {children}
            </FormControl>
            <FormHelperText className="Mui-error">{props.errorMessage}</FormHelperText>
        </>
    )
}

export default InputGroup;